import Link from 'next/link';

import cx from 'classnames';
import { CanvasAnimatedTile } from 'themes/canvas/components/CanvasAnimatedTile';
import { CanvasFooterReviews } from 'themes/canvas/components/FooterReviews/CanvasFooterReviews';
import { Marquee } from 'themes/canvas/components/Marquee/Marquee';
import { CanvasCtaViewMore } from 'themes/canvas/pages/CanvasHome/components/CanvasCtaViewMore';
import { CanvasService } from 'themes/canvas/pages/CanvasServices/components/CanvasService';

import { Heading } from 'components/Heading';

import { useAppContext } from 'hooks/context/useAppContext';
import { useHomePage } from 'hooks/page/home/useHomePage';
// import useDynamicFontSize from 'themes/canvas/components/utils';
import { ThemeModes, useGGTheme } from 'hooks/theme/useGGTheme';

import { ServiceOptionsModal } from 'routes/services/ServiceOptionsModal';

import { TService } from 'types/service';

import { EnergyHero } from '../components';

import s from 'themes/canvas/pages/CanvasHome/CanvasHome.module.css';

export const EnergyHome = () => {
  const {
    bookNowLinkUrl,
    heroImageSrc,
    services,
    onServiceClick,
    pendingSelectService,
    onSelectServiceOption,
    onCloseServiceOption,
    areGiftCardsEnabled = true,
    // reviews,
  } = useHomePage();

  const { publicUser } = useAppContext();
  const { themeMode } = useGGTheme();

  const serviceList = services.slice(0, 4);

  const items = services.map((service: TService) => service.name);

  return (
    <>
      <main className={s.homePage}>
        <EnergyHero
          imgSrc={heroImageSrc}
          businessName={publicUser.business_name}
        />
        <section
          className={cx(s.services, {
            [s.lightMode]: themeMode === ThemeModes.LIGHT,
            [s.darkMode]: themeMode === ThemeModes.DARK,
          })}
        >
          <div className={s.servicesLink}>
            <Heading as="h2">Services</Heading>
            <Link href={bookNowLinkUrl}>Book Now</Link>
          </div>
          <div className={s.servicesListContainer}>
            {serviceList &&
              serviceList.map((service: TService, idx: number) => (
                <CanvasAnimatedTile
                  className="serviceAnimatedTile"
                  key={service.guid}
                  threshold={0.1}
                >
                  <div key={idx}>
                    <CanvasService onClick={onServiceClick} service={service} />
                  </div>
                </CanvasAnimatedTile>
              ))}
          </div>
          {services.length > 0 && (
            <CanvasCtaViewMore to="/services" title="View All Services" />
          )}
        </section>
      </main>
      <div className={s.marquee}>
        <Marquee items={items} />
      </div>
      <section className={s.footerReviews}>
        <CanvasFooterReviews areGiftCardsEnabled={areGiftCardsEnabled} />
      </section>
      <ServiceOptionsModal
        service={pendingSelectService}
        onSelect={onSelectServiceOption}
        onClose={onCloseServiceOption}
      />
    </>
  );
};
